import controls from './controls';
import populate from './populate';


const setup = () => {
	L.mapbox.accessToken = 'pk.eyJ1IjoiYnJ5YW5kcmVlc2UiLCJhIjoiY2tucm5weXZqMDkzeTJvbWtkbHo5ZGRoNSJ9.0KZi07OLalOsfz5oOId8Og';
	Window.map = L.mapbox.map('map')
		.setView([39.966, -75.175], 13)
		.addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11'));
	Window.overlays = L.layerGroup().addTo(Window.map);
	controls.toggle();
}

export default {
	setup,
	populate
}
